import LoginEsqueceuSenha from '../views/LoginEsqueceuSenha.vue'
import CadastroNovaSenha from '../views/CadastroNovaSenha.vue'
import Alterar from 'core/views/Alterar.vue'
import PartnerNotFound from 'core/views/PartnerNotFound.vue'
import PartnerNotInformed from 'core/views/PartnerNotInformed.vue'
import Ativar from 'core/views/Ativar.vue'
import LoginSubparceiros from '../views/LoginSubparceiros.vue'

export default [
  {
    title: 'Início ',
    icon: 'fas fa-home',
    path: '/home',
    home: true,
    dir: 'views/',
    view: 'Home',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    path: '/partner/:parceiro',
    title: 'Login',
    menu: false,
    dir: 'views/',
    view: 'Login',
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/partner/:parceiro/preview',
    title: 'Preview',
    menu: false,
    dir: 'views/',
    view: 'Preview',
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/authToken/',
    dir: 'views/',
    view: 'LoginToken',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/sessao-expirada',
    title: 'Sessão expirada',
    menu: false,
    dir: 'views/',
    view: 'SessaoExpirada',
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/lembrar',
    component: LoginEsqueceuSenha,
    default: true,
    title: 'Lembrar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/cadastro-senha',
    component: CadastroNovaSenha,
    default: true,
    title: 'Cadastrar Nova Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/recuperar',
    component: Alterar,
    default: true,
    title: 'Alterar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/ativar',
    component: Ativar,
    default: true,
    title: 'Ativar conta',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/subparceiro',
    component: LoginSubparceiros,
    title: 'Login Subparceiro',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/partner-not-found',
    title: 'Parceiro não Identificado',
    menu: false,
    component: PartnerNotFound,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/',
    title: 'PartnerNotInformed',
    menu: false,
    component: PartnerNotInformed,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/aberturaconta',
    title: 'Abertura de conta',
    menu: false,
    dir: 'views/',
    view: 'AberturaConta',
    meta: {
      requiresAuth: true,
      roles: ['Multiplo.Gerente', 'Multiplo.Operador', 'Multiplo.Backoffice', 'Multiplo.Master']
    }
  },
  {
    title: 'Conta Movimento',
    path: '/movimento',
    menu: true,
    dir: 'views/ContaMovimentoAutenticada/',
    view: 'ContaMovimentoAutenticadaPresentation',
    meta: {
      anonymousAuth: true,
    }
  },
  {
    title: 'Dados Conta',
    path: '/dados-movimento',
    menu: true,
    dir: 'views/ContaMovimentoAutenticada/',
    view: 'ContaMovimentoAutenticadaPresentation',
    meta: {
      anonymousAuth: true,
    }
  },
  {
    title: 'Mobile',
    path: '/mobile',
    menu: false,
    toolbar: false,
    dir: 'views/Mobile/',
    view: 'Presentation',
    meta: {
      anonymousAuth: true,
    }
  },
  {
    title: 'Mobile Login',
    path: '/mobile/login',
    menu: false,
    toolbar: false,
    dir: 'views/Mobile/',
    view: 'Presentation',
    meta: {
      anonymousAuth: true,
    }
  },
  {
    title: 'Mobile Termo',
    path: '/mobile/termo',
    menu: false,
    toolbar: false,
    dir: 'views/Mobile/',
    view: 'Presentation',
    meta: {
      anonymousAuth: true,
    }
  },
  {
    title: 'Mobile Processo CAF',
    path: '/mobile/processo-caf',
    menu: false,
    toolbar: false,
    dir: 'views/Mobile/',
    view: 'Presentation',
    meta: {
      anonymousAuth: true,
    }
  },
  {
    title: 'Mobile Biometria Sucesso',
    path: '/mobile/aprovado',
    menu: false,
    toolbar: false,
    dir: 'views/Mobile/',
    view: 'Presentation',
    meta: {
      anonymousAuth: true,
    }
  },
]
